import { render, staticRenderFns } from "./CreditCollectionAccounts.vue?vue&type=template&id=afeaa94a&scoped=true&"
import script from "./CreditCollectionAccounts.vue?vue&type=script&lang=js&"
export * from "./CreditCollectionAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeaa94a",
  null
  
)

export default component.exports